import { cva } from "class-variance-authority";
export { default as Drawer } from "./Drawer.vue";
export { default as DrawerHeader } from "./DrawerHeader.vue";
export { default as DrawerTop } from "./DrawerTop.vue";
export {
    DialogContent as DrawerContent,
    DialogClose as DrawerClose,
    DialogFooter as DrawerFooter,
    DialogRoot as DrawerRoot,
    DialogTitle as DrawerTitle,
    DialogTrigger as DrawerTrigger,
    DialogSearch as DrawerSearch,
} from "@/SharedComponents/Dialog";

export const containerVariants = cva([], {
    variants: {
        variant: {},
    },
});

export const headerVariants = cva([], {
    variants: {
        variant: {},
    },
});
